import { Form } from 'react-bootstrap';
import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import Button from './Button';
import { Popover, PopoverContent, PopoverTrigger } from "utils/popover";
import { ChevronDown } from 'react-bootstrap-icons';
import './DropDown.scss'

interface Props {
  text?: string;
  itemsList?: DropDownItem[];
  activeFilter: any[];
  updateFilter: Dispatch<SetStateAction<any[]>>;
}

export interface DropDownItem {
  default?: boolean;
  id: any;
  name: string;
}

export function DropDownRadio(props: Props) {
  const { itemsList, activeFilter, updateFilter } = props;
  const [toShow, setToShow] = useState<DropDownItem[]>([]);

  const clearFilters = () => {
    updateFilter(itemsList?.filter(ts => ts.default)?.map(itm => itm.id) ?? []);
  };

  useEffect(() => {
    setToShow(itemsList ?? []);
  }, [itemsList]);

  return (
    <Popover placement="bottom-start">
      {popperBtn(props.text ?? "")}
      <PopoverContent>
        <div className='popper-filter-dropdown'>
          <ul className="list-unstyled">
            {toShow?.map((item) => (
              <li key={item?.id ?? item.name}>
                <Form.Check
                  type='radio'
                  id={`radio-${item.id}`}
                  checked={activeFilter.some(filter => filter === item.id)}
                  onChange={() => updateFilter([item.id])}
                  label={item?.name}
                />
              </li>
            ))}
          </ul>
          {clearBtn(clearFilters)}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export function DropDownFilterList(props: Props) {
  const { itemsList, activeFilter, updateFilter } = props;
  const [search, setSearch] = useState<string>('');
  const [toShow, setToShow] = useState<DropDownItem[]>([]);

  useEffect(() => {
    let toSet = itemsList?.filter(i => i.name.toLowerCase().includes(search.toLowerCase())) ?? [];
    setToShow(toSet);
  }, [itemsList, search]);

  const clearFilters = () => {
    updateFilter([]);
    setSearch("");
  };

  return (
    <Popover placement="bottom-start">
      {popperBtn(props.text ?? "")}
      <PopoverContent>
        <div className='popper-filter-dropdown' style={{ width: "230px" }}>
          <Form.Control
            className="mb-3"
            placeholder="Type to search..."
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
          <ul className="list-unstyled" style={{ overflow: "auto", maxHeight: "230px" }}>
            {toShow?.map((item) => (
              <li key={item?.id ?? item.name}
                onClick={() => {
                  const idx = activeFilter.find(it => it === item.id);
                  if (idx === undefined) {
                    updateFilter([...activeFilter, item.id]);
                  }
                  else {
                    updateFilter(activeFilter.filter(fi => fi !== item.id))
                  }
                }}>
                <Form.Check
                  type="checkbox"
                  readOnly={true}
                  checked={activeFilter.some(filter => filter === item.id)}
                  label={item?.name}
                />
              </li>
            ))}
          </ul>
          {clearBtn(clearFilters)}
        </div>
      </PopoverContent>
    </Popover>
  );
}

function clearBtn(clearFilters: () => void) {
  return <div style={{ display: 'flex' }}>
    <div style={{ flex: 1, alignContent: "flex-start" }}>
      <Button
        className="btn-dropdown-cl btn-sm"
        onClick={clearFilters}>
        Clear
      </Button>
    </div>
  </div>;
}

function popperBtn(text: string) {
  return <PopoverTrigger style={{ border: 'none', background: 'none' }}>
    <div className="btn btn-outline-primary btn-sm">
      {text}&nbsp;
      <ChevronDown />
    </div>
  </PopoverTrigger>;
}
